const jouwnetSettings = {
    jnStores: [
              {
                id: 'almere-01',
                // Openingstijden live uit Kas20 Connect; de times hieronder zijn de fallback.
                api_slug: 'kas20-almere',
                label: 'Almere',
                store_url: '/pages/meubel-showroom-bezoeken-almere',
                store_url_label: '<span data-langkey="general.look_inside"></span>',
                route_url: 'https://maps.app.goo.gl/6Uwj7K7YRjj7gPQB9',
                name: 'Showroom Almere',
                description: '<p class="description"><span data-langkey="general.full_assortiment"></span></p>',
                address: 'Radioweg 12<br>1324 KW, Almere<br>Flevoland',
                // store_img: 'https://cdn.shopify.com/s/files/1/0269/4840/3234/files/Screenshot_2024-02-15_at_23.41.00.jpg?v=1708036888',
                // store_img: '/cdn/shop/files/Frame_169_720x.jpg?v=1706176294',
                store_img: 'https://cdn.shopify.com/s/files/1/0269/4840/3234/files/WhatsApp_Image_2025-11-11_at_13.57.01.jpg?v=1762931491&width=500',
                // times: 'Ma gesloten<br>Di 10.00 - 17.00<br>Wo 10.00 - 17.00<br>Do 10.00 - 17.00<br>Vrij 10.00 - 17.00<br>Zat 10.00 - 17.00<br>Zo gesloten<br><a class="slt4_btn pe_auto round_ btn_icon_true btn_w_false theme-link jn-feestdagen" href="/pages/meubel-showroom-bezoeken-almere"><span data-langkey="general.showroom"></span></a>',
                times: [
                  // {
                  //       spacer: true
                  //   },
                  //   {
                  //       label: 'Koningsdag',
                  //       time: 'gesloten',
                  //       bold: true,
                  //   },
                    // {
                    //     spacer: true
                    // },
  //                 {
  //     label: 'Bevrijdingsdag',
  //     time: 'gesloten',
  //     bold: true,
  // },
  // {
  //     label: 'Hemelvaartsdag',
  //     time: '10.00 - 17.00',
  //     bold: true,
  // },
  // {
  //     label: '1e pinkersterdag',
  //     time: '11.00 - 15.00',
  //     bold: true,
  // },
  // {
  //     label: '2e pinksterdag',
  //     time: '11.00 - 15.00',
  //     bold: true,
  // },
  // {
  //     spacer: true
  // },

                
                  
                    {
                        label: 'Ma',
                        time: '09.00 - 17.30',
                    },
                    // {
                    //     label: 'Ma (2e Paasdag)',
                    //     time: '09.00 - 16.30',
                    // },
                    {
                        label: 'Di',
                        time: '09.00 - 17.30',
                    },
                    {
                        label: 'Wo',
                        time: '09.00 - 17.30',
                    },
                    {
                        label: 'Do',
                        time: '09.00 - 17.30',
                    },
                    {
                        label: 'Vr',
                        time: '09.00 - 17.30',
                    },
                    {
                        label: 'Za',
                        time: '10.00 - 17.00',
                    },
                    {
                        label: 'Zo',
                        time: 'gesloten',
                    },

                    // {
                    //     paragraph: '<span style="margin-top: 15px;margin-bottom: 4px;line-height:1.2;font-weight: 600;font-size: .8em;opacity: .8;color: var(--color-theme-orange);display: block;" classs="widget-title-muted">Speciale openingstijden</span>',
                    // },
                    //  {
                    //     label: '1e Pinksterdag (24 mei',
                    //     time: 'gesloten',
                    //     bold: true,
                    // },
                    // {
                    //     label: '2e Pinksterdag (25 mei',
                    //     time: '10.00 - 17.30',
                    //     bold: true,
                    // },
                //     {
                //         label: 'Goede vrijdag (Vr. 3-4)<br>',
                //         time: '10.00 - 17.00',
                //     },
                //   {
                //         label: '1e paasdag (Zo. 5-4)<br>',
                //         time: '11.00 - 15.00',
                //     },
                //   {
                //         label: '2e paasdag (Ma. 6-4)<br>',
                //         time: '11.00 - 15.00',
                //     },
                  // {
                  //       label: '1e Pinksterdag<br>',
                  //       time: 'gesloten',
                  //   },
                  // {
                  //       label: '2e Pinksterdag<br>',
                  //       time: '12.00 - 17.00',
                  //   },
                  // {
                  //       label: 'Goede vrijdag',
                  //       time: '10.00 - 17.00',
                  //   },
                  // {
                  //       label: '1e Paasdag',
                  //       time: 'gesloten',
                  //   },
                  // {
                  //       label: '2e Paasdag',
                  //       time: '12.00 - 17.00',
                  //   },
                  // {
                  //       label: 'Koningsdag',
                  //       time: 'Gesloten',
                  //   },
                  // {
                  //       label: '5 mei',
                  //       time: '10.00 - 17.00',
                  //       date: '05-05-2025'
                  //   },
                    
                    // {
                    //     label: '24-12) Di',
                    //     time: '10.00 - 16.00',
                    // },
                    // {
                    //     label: '1e kerstdag (Do 25-12)',
                    //     time: 'gesloten',
                    // },
                    // {
                    //     label: 'Oudjaarsdag (Wo 31-12)',
                    //     time: '10.00 - 15.00',
                    // },
                    // {
                    //     label: 'Nieuwjaarsdag (Do 01-01)',
                    //     time: 'gesloten',
                    // },
                    // {
                    //     label: '29-12) Zo',
                    //     time: 'gesloten',
                    // },
                    // {
                    //     label: '30-12) Ma',
                    //     time: '10.00 - 16.00',
                    // },
                    // {
                    //     // label: '31-12) Di',
                    //     label: 'Oudjaarsdag',
                    //     time: '10.00 - 15.00',
                    // },
                    // {
                    //     // label: '01-01) Wo',
                    //     label: 'Nieuwjaarsdag',
                    //     time: 'gesloten',
                    // },
                    // {
                    //     label: '05-01) Zo',
                    //     time: 'gesloten',
                    // },
  
                    {
                        spacer: true
                    },

                  
                    // {
                    //     paragraph: '<div style="margin-top: 10px;margin-bottom:10px;line-height:1.2;"><strong>Let op!</strong> Woensdag 6 maart gesloten.</div>',
                    // },
                    {
                        paragraph: '<a class="slt4_btn pe_auto round_ btn_icon_true btn_w_false theme-link jn-route" href="https://maps.app.goo.gl/6Uwj7K7YRjj7gPQB9" target="_blank">Route</a>',
                        types: ['footer']
                    },
                    {
                        paragraph: '<a class="slt4_btn pe_auto round_ btn_icon_true btn_w_false theme-link jn-feestdagen" href="/pages/meubel-showroom-bezoeken-almere"><span data-langkey="general.showroom"></span></a>',
                        types: ['footer']
                    },
                ],
            },
              
              {
                id: 'de-kwakel-01',
                // Openingstijden live uit Kas20 Connect; de times hieronder zijn de fallback.
                api_slug: 'kas20-de-kwakel',
                label: 'De Kwakel',
                store_url: '/pages/showroom-bezoeken-de-kwakel',
                store_url_label: '<span data-langkey="general.look_inside"></span>',
                route_url: 'https://maps.app.goo.gl/tSqnHe9BW3R37sct6',
                name: 'Showroom De Kwakel',
                description: '<p class="description"><span data-langkey="general.full_assortiment"></span></p>',
                address: 'Noorddammerweg 35<br>1424 NW, De Kwakel<br>Noord-Holland',
                // store_img: 'https://cdn.shopify.com/s/files/1/0269/4840/3234/files/Untitled_design_19_1296x.png?v=1650283399',
                // store_img: '/cdn/shop/files/Ontwerp_zonder_tihtel_720x.jpg?v=1710249627',
                // store_img: 'https://cdn.shopify.com/s/files/1/0269/4840/3234/files/IMG_7536_0edc5f3c-29c8-4710-8ef9-47c9af8aaee2_720x.jpg?v=1735644714',
                store_img: 'https://cdn.shopify.com/s/files/1/0269/4840/3234/files/WhatsApp_Image_2025-11-11_at_13.56.46.jpg?v=1762931487&width=500',
                // times: 'Ma 10.00 - 17.00 <br>Di 10.00 - 17.00 <br>Wo gesloten <br>Do 10.00 - 17.00 <br>Vr 10.00 - 17.00 <br>Zat 10.00 - 16.30 <br>Zo 11.00 - 13.00<br><a class="slt4_btn pe_auto round_ btn_icon_true btn_w_false theme-link jn-feestdagen" href="/pages/showroom-bezoeken-de-kwakel"><span data-langkey="general.showroom"></span></a>',
                times: [
                  // {
                  //       spacer: true
                  //   },
                  //   {
                  //       label: 'Koningsdag',
                  //       time: '10.00 - 15.00',
                  //       bold: true,
                  //   },
                  //   {
                  //       spacer: true
                  //   },
  
  //                 {
  //     label: 'Bevrijdingsdag',
  //     time: '11.00 - 15.00',
  //     bold: true,
  // },
  // {
  //     label: 'Hemelvaartsdag',
  //     time: '10.00 - 17.00',
  //     bold: true,
  // },
  // {
  //     label: '1e pinkersterdag',
  //     time: '11.00 - 15.00',
  //     bold: true,
  // },
  // {
  //     label: '2e pinksterdag',
  //     time: '10.00 - 16.00',
  //     bold: true,
  // },
  // {
  //     spacer: true
  // },
               
                    {
                        label: 'Ma',
                        time: '10.00 - 17.00',
                    },
                    // {
                    //     label: 'Ma (2e Paasdag)',
                    //     time: '10.00 - 16.30',
                    // },
                    {
                        label: 'Di',
                        time: '10.00 - 17.00',
                    },
                    {
                        label: 'Wo',
                        time: '10.00 - 17.00',
                    },
                    {
                        label: 'Do',
                        time: '10.00 - 17.00',
                    },
                    {
                        label: 'Vr',
                        time: '10.00 - 17.00',
                    },
                    {
                        label: 'Za',
                        time: '10.00 - 16.30',
                    },
                    {
                        label: 'Zo',
                        time: '11.00 - 15.00',
                    },

                    // Datum is voorbij; kopje meteen mee uitgezet, anders staat er een
                    // lege 'Speciale openingstijden' boven de openingstijden.
                    //  {
                    //     paragraph: '<span style="margin-top: 15px;margin-bottom: 4px;line-height:1.2;font-weight: 600;font-size: .8em;opacity: .8;color: var(--color-theme-orange);display: block;" classs="widget-title-muted">Speciale openingstijden</span>',
                    // },
                    // {
                    //     label: 'Vr (14 aug',
                    //     time: '10.00 - 15.30',
                    //     bold: true,
                    // },
                    // {
                    //     label: '2e Pinksterdag (25 mei',
                    //     time: '10.00 - 17.00',
                    //     bold: true,
                    // },
                    //   {
                    //     label: 'Koningsdag',
                    //     time: '11.00 - 15.00',
                    //     bold: true,
                    // },
                //     {
                //         label: 'Goede vrijdag (Vr. 3-4)<br>',
                //         time: '10.00 - 17.00',
                //     },
                //     {
                //         label: '1e paasdag (Zo. 5-4)<br>',
                //         time: '11.00 - 15.00',
                //     },
                //   {
                //         label: '2e paasdag (Ma. 6-4)<br>',
                //         time: '11.00 - 15.00',
                //     },
                    // {
                    //     label: 'Zondag (Do 25-01)',
                    //     time: '12.00 - 16.00',
                    // },
                    // {
                    //     label: '1e kerstdag (Do 25-12)',
                    //     time: 'gesloten',
                    // },
                    // {
                    //     label: '2e kerstdag (Vr 26-12)',
                    //     time: '10.00 - 14.00',
                    // },
                    // {
                    //     label: 'Oudjaarsdag (Wo 31-12)',
                    //     time: '10.00 - 15.00',
                    // },
                    // {
                    //     label: 'Nieuwjaarsdag (Do 01-01)',
                    //     time: 'gesloten',
                    // },
                  // {
                  //       label: '1e Pinksterdag<br>',
                  //       time: '11.00 - 15.00',
                  //   },
                  // {
                  //       label: '2e Pinksterdag<br>',
                  //       time: '11.00 - 15.00',
                  //   },

                  // {
                  //       label: 'Goede vrijdag',
                  //       time: '10.00 - 17.00',
                  //   },

                  // {
                  //       label: '1e Paasdag',
                  //       time: '11.00 - 15.00',
                  //   },
                  // {
                  //       label: '2e Paasdag',
                  //       time: '10.00 - 16.30',
                  //   },
                  // {
                  //       label: 'Koningsdag',
                  //       time: '10.00 - 16.30',
                  //   },
                  // {
                  //       label: '5 mei',
                  //       time: '10.00 - 16.30',
                  //   },

                  // {
                  //       paragraph: 'Let op! i.v.m. marathon zijn we later geopend.',
                  //   },
                  //   {
                  //       label: '26-01) Zo',
                  //       time: '12.00 - 16.00',
                  //   },
                    // // {
                    // //     // label: '25-12-24 (1e)',
                    // //     label: '1e kerstdag',
                    // //     time: 'gesloten',
                    // // },
                    // {
                    //     // label: '26-12-24 (2e)',
                    //     label: '2e kerstdag',
                    //     time: '10.00 - 16.00',
                    // },
                    // {
                    //     // label: '31-12-24',
                    //     label: 'Oudjaarsdag',
                    //     time: '10.00 - 15.00',
                    // },
                    // {
                    //     // label: '01-01-25',
                    //     label: 'Nieuwjaarsdag',
                    //     time: 'gesloten',
                    // },
                    {
                        spacer: true
                    },
                  
                    {
                        paragraph: '<a class="slt4_btn pe_auto round_ btn_icon_true btn_w_false theme-link jn-route" href="https://maps.app.goo.gl/tSqnHe9BW3R37sct6" target="_blank">Route</a>',
                        types: ['footer']
                    },
                    {
                        paragraph: '<a class="slt4_btn pe_auto round_ btn_icon_true btn_w_false theme-link jn-feestdagen" href="/pages/showroom-bezoeken-de-kwakel"><span data-langkey="general.showroom"></span></a>',
                        types: ['footer']
                    },
                ],
            },
            {
                id: 'helmond-01',
                // Openingstijden live uit Kas20 Connect; de times hieronder zijn de fallback.
                api_slug: 'kas20-helmond',
                label: 'Helmond',
                store_url: '/pages/showroom-bezoeken-helmond',
              store_url_label: '<span data-langkey="general.look_inside"></span>',
              route_url: 'https://goo.gl/maps/xDJtFf8jkohLCcbh7',
                name: 'Showroom Helmond',
                description: '<p class="description"><span data-langkey="general.full_assortiment"></span></p>',
                address: 'Nijverheidsweg 12a<br>5705 BN, Helmond<br>Noord-Brabant',
                // store_img: 'https://cdn.shopify.com/s/files/1/0269/4840/3234/files/Untitled_design_18_1296x.png?v=1650281972',
                // store_img: '/cdn/shop/files/Ontwerp_zonder_titel_720x.jpg?v=1710247751',
                store_img: '/cdn/shop/files/DSC0122.jpg?v=1750588547&width=600',
                // times: 'Ma gesloten<br>Di gesloten<br>Wo gesloten<br>Do gesloten<br>Vrij 12.00 - 16.00<br>Zat 10.00 - 16.00<br>Zo 12.00 - 16.00<br><a class="slt4_btn pe_auto round_ btn_icon_true btn_w_false theme-link jn-feestdagen" href="/pages/showroom-bezoeken-helmond"><span data-langkey="general.showroom"></span></a>',
                times: [
  
  //                 {
  //     label: 'Bevrijdingsdag',
  //     time: '12.00 - 16.00',
  //     bold: true,
  // },
  // {
  //     label: 'Hemelvaartsdag',
  //     time: '12.00 - 16.00',
  //     bold: true,
  // },
  // {
  //     label: '1e pinkersterdag',
  //     time: '12.00 - 16.00',
  //     bold: true,
  // },
  // {
  //     label: '2e pinksterdag',
  //     time: '12.00 - 16.00',
  //     bold: true,
  // },
  // {
  //     spacer: true
  // },
  
                   
                  
                  // {
                  //       spacer: true
                  //   },
                  //   {
                  //       label: 'Koningsdag',
                  //       time: '11.00 - 15.00',
                  //       bold: true,
                  //   },
                  //   {
                  //       spacer: true
                  //   },
                    {
                        label: 'Ma',
                        // time: 'gesloten',
                        time: '10.00 - 17.30',
                    },
                    // {
                    //     label: 'Ma (2e Paasdag)',
                    //     time: '10.00 - 16.00',
                    // },
                    {
                        label: 'Di',
                        time: '10.00 - 17.30',
                        // time: '11.00 - 15.00',
                    },
                    {
                        label: 'Wo',
                        // time: 'gesloten',
                      time: '10.00 - 17.30',
                    },
                    {
                        label: 'Do',
                        // time: 'gesloten',
                        time: '10.00 - 17.30',
                    },
                    {
                        label: 'Vr',
                        time: '10.00 - 17.30',
                    },
                    {
                        label: 'Za',
                        time: '10.00 - 16.30',
                    },
                    {
                        label: 'Zo',
                        time: '12.00 - 16.00',
                    },

                    // {
                    //     paragraph: '<span style="margin-top: 15px;margin-bottom: 4px;line-height:1.2;font-weight: 600;font-size: .8em;opacity: .8;color: var(--color-theme-orange);display: block;" classs="widget-title-muted">Speciale openingstijden</span>',
                    // },
                    // {
                    //     label: 'Za (27 jun',
                    //     time: '10.00 - 15.00',
                    //     bold: true,
                    // },
                    // {
                    //     label: '1e Pinksterdag (24 mei',
                    //     time: '12.00 - 16.00',
                    //     bold: true,
                    // },
                    // {
                    //     label: '2e Pinksterdag (25 mei',
                    //     time: '10.00 - 17.30',
                    //     bold: true,
                    // },
                    //   {
                    //     label: 'Koningsdag',
                    //     time: '10.00 - 14.00',
                    //     bold: true,
                    // },
                //     {
                //         label: 'Goede vrijdag (Vr. 3-4)<br>',
                //         time: '10.00 - 17.00',
                //     },
                //     {
                //         label: '1e paasdag (Zo. 5-4)<br>',
                //         time: '11.00 - 15.00',
                //     },
                //   {
                //         label: '2e paasdag (Ma. 6-4)<br>',
                //         time: '11.00 - 15.00',
                //     },
                    // {
                    //     label: 'Ma (16-02)',
                    //     time: '10.00 - 14.00',
                    // },
                    // {
                    //     label: 'Oudjaarsdag (Wo 31-12)',
                    //     time: '12.00 - 15.00',
                    // },
                    // {
                    //     label: 'Nieuwjaarsdag (Do 01-01)',
                    //     time: 'gesloten',
                    // },
                  // {
                  //       label: '1e Pinksterdag<br>',
                  //       time: '12.00 - 16.00',
                  //   },
                  // {
                  //       label: '2e Pinksterdag<br>',
                  //       time: '12.00 - 17.00',
                  //   },
                    //   {
                    //     label: 'Wo (26-02-25)',
                    //     time: '12.00 - 16.00',
                    // },

                  // {
                  //       label: 'Goede vrijdag',
                  //       time: '12.00 - 16.00',
                  //   },

                  // {
                  //       label: '1e Paasdag',
                  //       time: '12.00 - 16.00',
                  //   },
                  // {
                  //       label: '2e Paasdag',
                  //       time: '12.00 - 16.00',
                  //   },
                  // {
                  //       label: 'Koningsdag',
                  //       time: '12.00 - 16.00',
                  //   },
                  // {
                  //       label: '5 mei',
                  //       time: '10.00 - 16.00',
                  //   },
                  // {
                  //       label: 'Wo (12-03-25)',
                  //       time: '12.00 - 16.00',
                  //   },
                  // {
                  //       label: 'Wo (19-03-25)',
                  //       time: '12.00 - 16.00',
                  //   },
                  // {
                  //       label: 'Wo (26-03-25)',
                  //       time: '12.00 - 16.00',
                  //   },
                    // {
                    //     // label: '25-12-24 (1e)',
                    //     label: 'Ma (30-12-24)',
                    //     time: '11.00 - 16.00',
                    //     // time: 'gesloten',
                    // },
                    // {
                    //     // label: '26-12-24 (2e)',
                    //     label: '2e kerstdag',
                    //     time: '10.00 - 16.00',
                    // },
                    // {
                    //     // label: '31-12-24',
                    //     label: 'Oudjaarsdag',
                    //     time: 'gesloten',
                    // },
                    // {
                    //     // label: '01-01-25',
                    //     label: 'Nieuwjaarsdag',
                    //     time: 'gesloten',
                    // },
                    {
                        spacer: true
                    },
                  
                    {
                        paragraph: '<a class="slt4_btn pe_auto round_ btn_icon_true btn_w_false theme-link jn-route" href="https://goo.gl/maps/xDJtFf8jkohLCcbh7" target="_blank">Route</a>',
                        types: ['footer']
                    },
                    {
                        paragraph: '<a class="slt4_btn pe_auto round_ btn_icon_true btn_w_false theme-link jn-feestdagen" href="/pages/showroom-bezoeken-helmond"><span data-langkey="general.showroom"></span></a>',
                        types: ['footer']
                    },
                ],
            },
            {
                // Showroom Enschede is gesloten (oktober 2026, vervangen door Oldenzaal). Verborgen in
                // showroomoverzicht, popups en formulieren; gegevens blijven staan voor als hij terugkomt.
                id: 'enschede-01',
                hide: true,
                label: 'Enschede',
                store_url: '/pages/meubel-showroom-bezoeken-enschede',
              store_url_label: '<span data-langkey="general.look_inside"></span>',
              route_url: 'https://maps.app.goo.gl/QiiDNSBc5aJ52LaZ6',
                name: 'Showroom Enschede',
                description: '<p class="description"><span data-langkey="general.full_assortiment"></span></p>',
                address: 'Lage Bothofstraat 159A<br>7533 AS, Enschede<br>Overijssel',
                // store_img: 'https://cdn.shopify.com/s/files/1/0269/4840/3234/files/Untitled_design_18_1296x.png?v=1650281972',
                // store_img: '/cdn/shop/files/Scherm_afbeelding_2024-03-12_om_15.03.26_720x.png?v=1710252221',
                store_img: 'https://cdn.shopify.com/s/files/1/0269/4840/3234/files/DSC0166.jpg?v=1750602393&width=600',
                // times: 'Ma gesloten<br>Di 10.00 - 17.00<br>Wo 10.00 - 17.00<br>Do 10.00 - 17.00<br>Vrij 10.00 - 17.00<br>Zat 10.00 - 17.00<br>Zo gesloten<br><a class="slt4_btn pe_auto round_ btn_icon_true btn_w_false theme-link jn-feestdagen" href="/pages/showroom-bezoeken-almere"><span data-langkey="general.showroom"></span></a>',
                times: [
  
  //                 {
  //     label: 'Bevrijdingsdag',
  //     time: '11.00 - 15.00',
  //     bold: true,
  // },
  // {
  //     label: 'Hemelvaartsdag',
  //     time: '11.00 - 15.00',
  //     bold: true,
  // },
  // {
  //     label: '1e pinkersterdag',
  //     time: '11.00 - 15.00',
  //     bold: true,
  // },
  // {
  //     label: '2e pinksterdag',
  //     time: '11.00 - 15.00',
  //     bold: true,
  // },
  // {
  //     spacer: true
  // },
                  
                    // {
                    //     paragraph: '<strong>Let op!</strong> Open vanaf 24 februari',
                    // },
                    // {
                    //     paragraph: '<strong>Let op!</strong> 25 februari gesloten',
                    // },
                  // {
                  //       spacer: true
                  //   },
                  //   {
                  //       label: 'Koningsdag',
                  //       time: '11.00 - 16.00',
                  //       bold: true,
                  //   },
                  //   {
                  //       spacer: true
                  //   },

               
                  
                    {
                        label: 'Ma',
                        time: 'gesloten',
                        // time: '11.00 - 16.00',
                    },
                    // {
                    //     label: 'Ma',
                    //     time: '11.00 - 15.00 (2e Paasdag)',
                    // },
                    {
                        label: 'Di',
                        time: 'op afspraak',
                    },
                    {
                        label: 'Wo',
                        time: 'gesloten',
                    },
                    {
                        label: 'Do',
                        time: 'gesloten',
                    },
                    {
                        label: 'Vr',
                        time: '11.00 - 15.00',
                    },
                    {
                        label: 'Za',
                        time: '11.00 - 16.00',
                    },
                    {
                        label: 'Zo',
                        time: '11.00 - 15.00',
                    },
{
                        paragraph: '<span style="margin-top: 15px;margin-bottom: 4px;line-height:1.2;font-weight: 600;font-size: .8em;opacity: .8;color: var(--color-theme-orange);display: block;" classs="widget-title-muted">Speciale openingstijden</span>',
                    },
                    {
                        label: 'Zo (13-09',
                        time: 'gesloten',
                        bold: true,
                    },
                    //   {
                    //     paragraph: '<span style="margin-top: 15px;margin-bottom: 4px;line-height:1.2;font-weight: 600;font-size: .8em;opacity: .8;color: var(--color-theme-orange);display: block;" classs="widget-title-muted">Speciale openingstijden</span>',
                    // },
                    // {
                    //     label: '1e Pinksterdag (24 mei',
                    //     time: 'gesloten',
                    //     bold: true,
                    // },
                    // {
                    //     label: '2e Pinksterdag (25 mei',
                    //     time: '11.00 - 15.00',
                    //     bold: true,
                    // },
                    //   {
                    //     label: 'Koningsdag',
                    //     time: 'gesloten',
                    //     bold: true,
                    // },
                //     {
                //         label: 'Goede vrijdag (Vr. 3-4)<br>',
                //         time: '11.00 - 15.00',
                //     },
                //     {
                //         label: '1e paasdag (Zo. 5-4)<br>',
                //         time: 'gesloten',
                //     },
                //   {
                //         label: '2e paasdag (Ma. 6-4)<br>',
                //         time: '12.00 - 16.00',
                //     },
                //     {
                //         label: 'Zo 12-4',
                //         time: 'gesloten',
                //     },
                    // {
                    //     label: '1e kerstdag (Do 25-12)',
                    //     time: 'gesloten',
                    // },
                    // {
                    //     label: '2e kerstdag (Vr 26-12)',
                    //     time: '11.00 - 15.00',
                    // },
                    // {
                    //     label: 'Oudjaarsdag (Wo 31-12)',
                    //     time: 'gesloten',
                    // },
                    // {
                    //     label: 'Nieuwjaarsdag (Do 01-01)',
                    //     time: 'gesloten',
                    // },
                    // {
                    //     label: 'Vrijdag 02-01)',
                    //     time: 'gesloten',
                    // },

                    //                 {
                    //     label: '14-09 (Zo)<br>',
                    //     time: 'gesloten',
                    // },
                  // {
                  //       label: '2e Pinksterdag<br>',
                  //       time: '11.00 - 15.00',
                  //   },

                  // {
                  //       label: 'Do 29 mei (Hemelvaart)<br>',
                  //       time: '11.00 - 15.00',
                  //   },
                  // {
                  //       label: 'Zo (18-05)',
                  //       time: '11.00 - 14.00',
                  //   },
                  // {
                  //       label: '1e Paasdag',
                  //       time: 'gesloten',
                  //   },
                  // {
                  //       label: '2e Paasdag',
                  //       time: '11.00 - 16.00',
                  //   },
                  // {
                  //       label: 'Koningsdag',
                  //       // time: '11.00 - 16.00',
                  //       time: 'gesloten',
                  //   },
                  // {
                  //       label: '5 mei',
                  //       time: '12.00 - 15.00',
                  //   },

                    // {
                    //     // label: '25-12-24 (1e)',
                    //     label: '1e kerstdag',
                    //     time: 'gesloten',
                    // },
                    // {
                    //     // label: '26-12-24 (2e)',
                    //     label: '2e kerstdag',
                    //     time: '11.00 - 16.00',
                    // },
                    // {
                    //     label: '27-12-24',
                    //     time: '11.00 - 15.00',
                    // },
                    // {
                    //     label: '28-12-24',
                    //     time: '11.00 - 16.00',
                    // },
                    // {
                    //     label: '29-12-24',
                    //     time: '11.00 - 15.00',
                    // },
                    {
                        spacer: true
                    },
                  // {
                  //       paragraph: '<div style="margin-top: 10px;margin-bottom:10px;line-height:1.2;"><strong>Let op!</strong> Woensdag 6 maart gesloten.</div>',
                  //   },
                  {
                        paragraph: '<a class="slt4_btn pe_auto round_ btn_icon_true btn_w_false theme-link jn-route" href="https://maps.app.goo.gl/QiiDNSBc5aJ52LaZ6" target="_blank">Route</a>',
                        types: ['footer']
                    },
                    {
                        paragraph: '<a class="slt4_btn pe_auto round_ btn_icon_true btn_w_false theme-link jn-feestdagen" href="/pages/meubel-showroom-bezoeken-enschede"><span data-langkey="general.showroom"></span></a>',
                        types: ['footer']
                    },
                ]
            },
            {
                // Opent 30 oktober 2026 (vervangt Enschede). Tot dan staat hij in Kas20 Connect per dag
                // op gesloten met de notitie "Opent op 30 oktober".
                // Openingstijden komen live uit Kas20 Connect (Store → Openingstijden) via api_slug;
                // de times hieronder zijn alleen de fallback als die API niet antwoordt.
                id: 'oldenzaal-01',
                api_slug: 'kas20-oldenzaal',
                // hide: true,
                hide: false,
                label: 'Oldenzaal',
                store_url: '/pages/meubel-showroom-bezoeken-oldenzaal',
                store_url_label: '<span data-langkey="general.look_inside"></span>',
                route_url: 'https://www.google.com/maps/dir/?api=1&destination=Ainsworthstraat+30%2C+7575+BT+Oldenzaal',
                name: 'Showroom Oldenzaal',
                description: '<p class="description"><span data-langkey="general.full_assortiment"></span></p>',
                address: 'Ainsworthstraat 30<br>7575 BT, Oldenzaal<br>Overijssel',
                // store_img: 'https://cdn.shopify.com/s/files/1/0269/4840/3234/files/KAS20_Website_header_Actie_pagina_WINKELS_1.jpg?v=1732272587&width=600',
                store_img: 'https://cdn.shopify.com/s/files/1/0269/4840/3234/files/kas20-hoek.png?width=600',
                times: [
                    // {
                    //     paragraph: '<strong>Opent eind oktober 2026</strong>',
                    // },
                    {
                        paragraph: '<strong>Open vanaf 30 oktober 2026</strong>',
                    },
                    {
                        label: 'Ma',
                        time: '10.00 - 17.00',
                    },
                    {
                        label: 'Di',
                        time: '10.00 - 17.00',
                    },
                    {
                        label: 'Wo',
                        time: '10.00 - 17.00',
                    },
                    {
                        label: 'Do',
                        time: '10.00 - 17.00',
                    },
                    {
                        label: 'Vr',
                        time: '10.00 - 17.00',
                    },
                    {
                        label: 'Za',
                        time: '10.00 - 17.00',
                    },
                    {
                        label: 'Zo',
                        time: '11.00 - 15.00',
                    },
                    {
                        spacer: true
                    },
                    {
                        paragraph: '<a class="slt4_btn pe_auto round_ btn_icon_true btn_w_false theme-link jn-route" href="https://www.google.com/maps/dir/?api=1&destination=Ainsworthstraat+30%2C+7575+BT+Oldenzaal" target="_blank">Route</a>',
                        types: ['footer']
                    },
                    {
                        paragraph: '<a class="slt4_btn pe_auto round_ btn_icon_true btn_w_false theme-link jn-feestdagen" href="/pages/meubel-showroom-bezoeken-oldenzaal"><span data-langkey="general.showroom"></span></a>',
                        types: ['footer']
                    },
                ],
            },
            {
                id: 'oudbeijerland-01',
                hide: false,
                label: 'Outlet Oud-Beijerland',
                store_url: '/collections/kas20-outlet-oud-beijerland',
                store_url_label: 'Outlet selectie, wisselt per dag',
                route_url: 'https://maps.app.goo.gl/HeJ6tAPxCBvyCaW77',
                name: 'Outlet Oud-Beijerland',
                description: '<p class="description">Outlet selectie, wisselt per dag</p>',
                address: 'Julianastraat 45<br>3262 SH, Oud-Beijerland<br>Zuid-Holland',
                // store_img: 'https://cdn.shopify.com/s/files/1/0269/4840/3234/files/Screenshot_2024-02-15_at_23.41.00.jpg?v=1708036888',
                store_img: 'https://cdn.shopify.com/s/files/1/0269/4840/3234/files/Screenshot_2026-03-10_at_15.27.37.png?v=1773161118',
                times: [
                    {
                        label: 'Ma',
                        time: 'gesloten',
                    },
                    {
                        label: 'Di',
                        time: 'gesloten',
                    },
                    {
                        label: 'Wo',
                        time: 'gesloten',
                    },
                    {
                        label: 'Do',
                        time: 'gesloten',
                    },
                    {
                        label: 'Vr',
                        time: 'op afspraak',
                    },
                    {
                        label: 'Za',
                        time: '10.00 - 16.00',
                    },
                    {
                        label: 'Zo',
                        time: 'gesloten',
                    },
                    //    {
                    //     paragraph: '<span style="margin-top: 15px;margin-bottom: 4px;line-height:1.2;font-weight: 600;font-size: .8em;opacity: .8;color: var(--color-theme-orange);display: block;" classs="widget-title-muted">Speciale openingstijden</span>',
                    // },
                    // {
                    //     label: 'Vr (15-06',
                    //     time: 'gesloten',
                    //     bold: true,
                    // },
                    {
                        spacer: true
                    },
                    {
                        paragraph: '<a class="slt4_btn pe_auto round_ btn_icon_true btn_w_false theme-link jn-route" href="https://maps.app.goo.gl/HeJ6tAPxCBvyCaW77" target="_blank">Route</a>',
                        types: ['footer']
                    },
                    {
                        paragraph: '<a class="slt4_btn pe_auto round_ btn_icon_true btn_w_false theme-link jn-feestdagen" href="/collections/kas20-outlet-oud-beijerland"><span data-langkey="general.showroom"></span></a>',
                        types: ['footer']
                    },
                ],
            },
            {
                id: 'amsterdam-01',
                // Openingstijden live uit Kas20 Connect; de times hieronder zijn de fallback.
                api_slug: 'kas20-amsterdam',
                label: 'Outlet Amsterdam',
                store_url: '/pages/meubel-outlet-bezoeken-amsterdam',
                store_url_label: 'Outlet selectie, wisselt per dag',
                name: 'Outlet Amsterdam',
                description: '<p class="description">Outlet selectie, wisselt per dag</p>',
                address: 'Commelinstraat 11-0<br>1093 TE, Amsterdam<br>Noord-Holland',
                store_img: 'https://cdn.shopify.com/s/files/1/0269/4840/3234/files/Untitled_design_20_1296x.png?v=1650283373',
                // times: 'Ma gesloten<br>Di gesloten<br>Wo gesloten<br>Do gesloten<br>Vr gesloten<br>Zat 10.00 - 17.00<br>1e zondag van de maand 12:00 - 16:00<br><a class="slt4_btn pe_auto round_ btn_icon_true btn_w_false theme-link jn-feestdagen" href="/pages/showroom-bezoeken-amsterdam"><span data-langkey="general.showroom"></span></a>',
                times: [
                  // {
                  //       spacer: true
                  //   },
                  //   {
                  //       label: 'Koningsdag',
                  //       time: 'gesloten',
                  //       bold: true,
                  //   },
                  //   {
                  //       spacer: true
                  //   },

  
                  
                    {
                        label: 'Ma',
                        time: 'gesloten',
                    },
                    {
                        label: 'Di',
                        time: 'gesloten',
                    },
                    {
                        label: 'Wo',
                        time: 'gesloten',
                    },
                    {
                        label: 'Do',
                        time: 'gesloten',
                    },
                    {
                        label: 'Vr',
                        time: '12:00 - 17.00',
                    },
                  {
                        label: 'Za',
                        time: '10.00 - 17.00',
                    },
                  {
                        label: 'Zo',
                        time: 'gesloten',
                    },

                  
                  
                      {
                        paragraph: '<span style="margin-top: 15px;margin-bottom: 4px;line-height:1.2;font-weight: 600;font-size: .8em;opacity: .8;color: var(--color-theme-orange);display: block;" classs="widget-title-muted">Speciale openingstijden</span>',
                    },

                //   {
                //       time: 'gesloten',
                //         label: 'Vr (28-08',
                //     },
                //   {
                //       time: 'gesloten',
                //         label: 'Vr (29-08',
                //     },
                //   {
                //       time: 'gesloten',
                //         label: 'Vr (04-09',
                //     },
                //   {
                //       time: 'gesloten',
                //         label: 'Vr (05-09',
                //     },
                  {
                      time: 'gesloten',
                        label: 'Vr (18-09',
                    },
    //               // {
    //               //       label: '2e Paasdag',
    //               //       time: '12.00 - 16.00',
    //               //   },
    //               // {
    //               //       label: 'Koningsdag',
    //               //       time: 'gesloten',
    //               //   },
    //               // {
    //               //       label: 'Vanaf 1 mei',
    //               //       time: 'gesloten',
    //               //   },
    //               {
    //                     label: '5 mei',
    //                     time: 'gesloten',
    //                 },
  
    //               //  {
    //               //       label: '23-12-24',
    //               //       time: 'gesloten',
    //               //   },
    //               // {
    //               //       label: '24-12-24',
    //               //       time: 'gesloten',
    //               //   },
    //               //   {
    //               //       // label: '25-12-24 (1e)',
    //               //       label: '1e kerstdag',
    //               //       time: 'gesloten',
    //               //   },
    //               //   {
    //               //       // label: '26-12-24 (2e)',
    //               //       label: '2e kerstdag',
    //               //       time: 'gesloten',
    //               //   },
    //                 // {
    //                 //     label: '31-12-24',
    //                 // label: 'Oudjaarsdag',
    //                 //     time: '10.00 - 15.00',
    //                 // },
    //               //   {
    //               //       // label: '01-01-25',
    //               //       label: 'Nieuwjaarsdag',
    //               //       time: 'gesloten',
    //               //   },
  
    //                 {
    //                     spacer: true
    //                 },
    //                 // {
    //                 //     label: 'Za',
    //                 //     time: '10.00 - 17.00',
    //                 // },
    //                 // {
    //                 //     label: 'Zo',
    //                 //     time: '1e zondag van de maand 12:00 - 16:00',
    //                 // },
                    {
                        paragraph: '<a class="slt4_btn pe_auto round_ btn_icon_true btn_w_false theme-link jn-route" href="https://maps.app.goo.gl/vBh7QsKjPHNJLGvs6" target="_blank">Route</a>',
                        types: ['footer']
                    },
                    {
                        paragraph: '<a class="slt4_btn pe_auto round_ btn_icon_true btn_w_false theme-link jn-feestdagen" href="/pages/meubel-outlet-bezoeken-amsterdam"><span data-langkey="general.showroom"></span></a>',
                        types: ['footer']
                    },
                ],
            },
            // {
            //     id: 'rotterdam-01',
            //     label: 'Oud-Beijerland',
            //     store_url: '/pages/showroom-oud-beijerland',
      // store_url_label: '<span data-langkey="general.look_inside"></span>',
            //     name: 'Showroom Oud-Beijerland',
            //     description: '<p class="description">Pilotwinkel zonder personeel. Hier vind je alleen onze collectie:<br><a class="footer-btn" href="/collections/aanbieding-eettafels">Super Deals</a></p>',
            //     address: 'Julianastraat 45<br>3262 SH, Oud-Beijerland<br>Zuid-Holland',
            //     // times: 'Ma gesloten<br>Di gesloten<br>Wo gesloten<br>Do gesloten<br>Vr gesloten<br>Zat 10.00 - 17.00<br>1e zondag van de maand 12:00 - 16:00<br><a class="slt4_btn pe_auto round_ btn_icon_true btn_w_false theme-link jn-feestdagen" href="/pages/showroom-bezoeken-amsterdam"><span data-langkey="general.showroom"></span></a>',
            //     times: [
            //         {
            //             label: 'Ma',
            //             time: '08.00 - 22.00',
            //         },
            //         {
            //             label: 'Di',
            //             time: '08.00 - 22.00',
            //         },
            //         {
            //             label: 'Wo',
            //             time: '08.00 - 22.00',
            //         },
            //         {
            //             label: 'Do',
            //             time: '08.00 - 22.00',
            //         },
            //         {
            //             label: 'Vr',
            //             time: '08.00 - 22.00',
            //         },
            //       {
            //             label: 'Za',
            //             time: '08.00 - 22.00',
            //         },
            //       {
            //             label: 'Zo',
            //             time: '08.00 - 22.00',
            //         },

                  
                  
            //         //   {
            //         //     paragraph: '<span style="margin-top: 15px;margin-bottom: 4px;line-height:1.2;font-weight: 600;font-size: .8em;opacity: .8;color: var(--color-theme-orange);display: block;" classs="widget-title-muted">Speciale openingstijden</span>',
            //         // },
  
            //       //  {
            //       //       label: '23-12-24',
            //       //       time: 'gesloten',
            //       //   },
            //       // {
            //       //       label: '24-12-24',
            //       //       time: 'gesloten',
            //       //   },
            //       //   {
            //       //       // label: '25-12-24 (1e)',
            //       //       label: '1e kerstdag',
            //       //       time: 'gesloten',
            //       //   },
            //       //   {
            //       //       // label: '26-12-24 (2e)',
            //       //       label: '2e kerstdag',
            //       //       time: 'gesloten',
            //       //   },
            //         // {
            //         //     label: '31-12-24',
            //         // label: 'Oudjaarsdag',
            //         //     time: '10.00 - 15.00',
            //         // },
            //       //   {
            //       //       // label: '01-01-25',
            //       //       label: 'Nieuwjaarsdag',
            //       //       time: 'gesloten',
            //       //   },
  
            //         {
            //             spacer: true
            //         },
            //         // {
            //         //     label: 'Za',
            //         //     time: '10.00 - 17.00',
            //         // },
            //         // {
            //         //     label: 'Zo',
            //         //     time: '1e zondag van de maand 12:00 - 16:00',
            //         // },
            //         {
            //             paragraph: '<a class="slt4_btn pe_auto round_ btn_icon_true btn_w_false theme-link jn-route" href="https://maps.app.goo.gl/uNq4VKSDUqrV8cpz5" target="_blank">Route</a>',
            //             types: ['footer']
            //         },
            //         // {
            //         //     paragraph: '<a class="slt4_btn pe_auto round_ btn_icon_true btn_w_false theme-link jn-feestdagen" href="/pages/showroom-bezoeken-amsterdam"><span data-langkey="general.showroom"></span></a>',
            //         //     types: ['footer']
            //         // },
            //     ],
            // },
            // {
            //     id: 'rotterdam-01',
            //     store_url: '/pages/oud-beijerland',
      // store_url_label: '<span data-langkey="general.look_inside"></span>',
            //     name: 'Superdeals Oud-Beijerland',
            //     description: '<p class="description">Pilotwinkel zonder personeel. Hier vind je alleen onze collectie:<br><a class="footer-btn" href="/collections/aanbieding-eettafels">Super Deals</a></p>',
            //     address: 'Julianastraat 45<br>3226 SH, Oud-Beijerland<br>Zuid-Holland',
            //     store_img: 'https://cdn.shopify.com/s/files/1/0269/4840/3234/files/frame-kiosk_1296x.jpg?v=1673453517',
            //     times: 'Ma 10.00 - 17.00 <br>Di 10.00 - 17.00 <br>Wo 10.00 - 17.00 <br>Do 10.00 - 17.00 <br>Vr 10.00 - 17.00 <br>Zat 10.00 - 17.00 <br>Zo 10.00 - 17.00<br><a class="slt4_btn pe_auto round_ btn_icon_true btn_w_false theme-link jn-feestdagen" href="/pages/oud-beijerland"><span data-langkey="general.showroom"></span></a>',
            // },
          {
                id: 'maak-een-afspraak',
                label: 'Op afspraak',
                store_url: '/pages/winkelafspraak',
                store_url_label: 'Afspraak',
                name: 'Bezoek op afspraak',
                description: '<p class="description">Wil je op afspraak langs komen? Dat kan altijd! Maak een afspraak via het formulier of bel ons op <a href="tel:0202101966">020-2101966</a>.</p>',
                address: 'Te overleggen',
                // store_img: 'https://cdn.shopify.com/s/files/1/0269/4840/3234/files/Screenshot_2024-02-15_at_23.41.00.jpg?v=1708036888',
                // store_img: '/cdn/shop/files/Screenshot_2023-11-01_at_08.54.15_720x.png?v=1698825268',
                store_img: 'https://cdn.shopify.com/s/files/1/0269/4840/3234/files/Frame_1012_720x.jpg?v=1717253964&width=600',
                // times: 'Ma gesloten<br>Di 10.00 - 17.00<br>Wo 10.00 - 17.00<br>Do 10.00 - 17.00<br>Vrij 10.00 - 17.00<br>Zat 10.00 - 17.00<br>Zo gesloten<br><a class="slt4_btn pe_auto round_ btn_icon_true btn_w_false theme-link jn-feestdagen" href="/pages/meubel-showroom-bezoeken-almere"><span data-langkey="general.showroom"></span></a>',
                times: [
                    {
                        label: 'Ma',
                        time: 'Op afspraak',
                    },
                    {
                        label: 'Di',
                        time: 'Op afspraak',
                    },
                    {
                        label: 'Wo',
                        time: 'Op afspraak',
                    },
                    {
                        label: 'Do',
                        time: 'Op afspraak',
                    },
                    {
                        label: 'Vr',
                        time: 'Op afspraak',
                    },
                    {
                        label: 'Za',
                        time: 'Op afspraak',
                    },
                    {
                        label: 'Zo',
                        time: 'Op afspraak',
                    },
                    // {
                    //     paragraph: '<div style="margin-top: 10px;margin-bottom:10px;line-height:1.2;"><strong>Let op!</strong> Woensdag 6 maart gesloten.</div>',
                    // },
                    {
                        paragraph: '<a class="slt4_btn pe_auto round_ btn_icon_true btn_w_false theme-link jn-call" href="tel:0202101966" target="_blank">Bellen</a>',
                    },
                    {
                        paragraph: '<a class="slt4_btn pe_auto round_ btn_icon_true btn_w_false theme-link jn-contact" href="/pages/contact-1">Contact formulier</a>',
                    },
                ],
            },
        ]
  }